<template>
    <v-container fluid grid-list-xs>
        <Loader ref="Loader"></Loader>
        <SuccessModal ref="SuccessModal"></SuccessModal>
        <ErrorModal ref="ErrorModal"></ErrorModal>
        <v-layout>
            <v-flex xs12 sm12 md12 lg12 xl12 text-xs-center>
                <h3 style="font-size: 2em;">{{ TranslateText("Account Feature Shop")}}</h3>
                <br>
            </v-flex>

        </v-layout>
        <v-container xs12>
            <v-layout align-end justify-end row ma-1>
                <v-btn color="primary" :disabled="cartItemCount <= 0" @click="cartDialog = true">
                    <v-icon>shopping_cart</v-icon>
                    {{TranslateText("Cart")}} ({{ cartItemCount }})
                </v-btn>
            </v-layout>
            <v-layout row wrap>
                <v-flex xs4 sm4 md6 lg6 xl6 v-for="item in features" :key="item.ID">
                    <v-card class="item">
                        <v-toolbar color="primary" dense>
                            <v-toolbar-title class="toolbar-title" style="text-align: center">{{ item.Name }}</v-toolbar-title>
                        </v-toolbar>
                        <br>
                        {{ item.Description }}
                        <br><br><br>
                        <v-layout align-end justify-end row fill-height ma-2>
                            <v-btn color="primary" @click="AddToCart(item)">
                                <h2><b>${{ item.FeatureCost }} </b></h2>
                            </v-btn>
                        </v-layout>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
        <!-- CART DIALOG -->
        <v-dialog v-model="cartDialog" persistent max-width="800px">
            <v-card>
                <v-card-title>
                    <h3><b>{{ TranslateText("Checkout")}}</b></h3>
                </v-card-title>
                <v-divider></v-divider>
                <br>
                <v-layout ma-1>
                    <v-flex xs12>
                        <table>
                            <tr>
                                <!-- <th v-for="column in columns" :key="column.index" width="20%">{{column}}</th> -->
                                <th width="77%" style="text-align: start">Feature</th>
                                <th width="23%" style="text-align: start">Price</th>
                                <th></th>
                            </tr>
                            <tr v-for="cartItem in cartItems" :key="cartItem.id" class="table_value">
                                <td width="77%">{{cartItem.Name}}</td>
                                <td width="23%">{{cartItem.FeatureCost}}</td>
                                <td><i class="material-icons delete_btn" @click="deleteCartItem(cartItem)">clear</i></td>
                            </tr>
                            <br>
                            <tr>
                                <td width="77%"></td>
                                <td width="23%"><u><b>Total Price:</b></u></td>
                                <td>{{ totalCost }}</td>
                            </tr>
                        </table>
                    </v-flex>
                </v-layout>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="success" @click="CheckOut(), entToggle=true">Checkout</v-btn>
                    <v-btn color="error" @click.native="cartDialog = false">Cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    export default {
        data() {
            return {
                columns: ['Feature', 'Price'],
                features: [],
                cartItems: [],
                cartItemCount: 0,
                cartItemID: null,
                cartDialog: false,
                cartItemNames: [],
                cartItemPrices: [],
                totalCost: 0
            }
        },
        mounted() {
            let self = this;

            self.fetchData();
        },
        created() {

        },
        methods: {
            routeTo(item) {
                let self = this;
                self.$router.push(item.route);
            },
            deleteCartItem(cartItem) {
                let self = this;

                var index = self.cartItems.indexOf(cartItem);
                if (index > -1) {
                    self.cartItems.splice(index, 1);
                    self.totalCost = self.totalCost - cartItem.FeatureCost;
                    self.cartItemCount = self.cartItemCount - 1;
                }

                // var priceIndex = self.cartItemPrices.indexOf(cartItem);
                // if (priceIndex > -1) {
                //     self.cartItemPrices.splice(priceIndex, 1);
                // }

            },
            fetchData() {
                let self = this;

                self.$refs.Loader.show();
                self.get('AccountFeature/InactiveFeatures')
                    .then(response => {
                        self.$refs.Loader.hide();
                        console.log("[ACCOUNT-SHOP]", response.data)
                        self.features = response.data;

                        if (self.features < 0) {
                            self.$refs.ErrorModal.show();
                            self.$refs.ErrorModal.setText("There are currently no features available.");
                        }
                    })
                    .catch(err => {
                        console.error(err);
                        self.$refs.Loader.hide()
                        self.$refs.ErrorModal.show();
                        self.$refs.ErrorModal.setText("Failed to get features");
                    });
            },
            AddToCart(item) {
                let self = this;
                self.$refs.Loader.show();


                var feature = self.cartItems.filter(el => {
                    return item == el;
                })

                // checking if item is already in cart
                if (feature.length > 0) {
                    self.$refs.ErrorModal.show();
                    self.$refs.ErrorModal.setText("Item is already in the cart");
                    setTimeout(function () { // hide modal after 1 second
                        self.$refs.ErrorModal.hide();
                    }, 1000)
                } else {
                    self.cartItems.push(item); //adding item to the cart array
                    self.$refs.SuccessModal.show(); // success modal
                    self.$refs.SuccessModal.setText("Added to cart");
                    self.cartItemCount = self.cartItems.length;
                    self.cartItemPrices.push(item.FeatureCost)

                    console.log(self.cartItemPrices)

                    for (var i = 0; i < self.cartItemPrices.length; i++) {
                        self.totalCost = self.cartItemPrices.reduce(function (sum, value) {
                            return sum + value;
                        }, 0);
                        console.log(self.totalCost)
                    }

                    setTimeout(function () {
                        self.$refs.SuccessModal.hide();
                    }, 800)
                }
                self.$refs.Loader.hide();
            },
            CheckOut() {
                let self = this;

                self.cartDialog = false;
                var Request = {};

                if (self.cartItemCount == 0) {
                    self.$refs.ErrorModal.show();
                    self.$refs.ErrorModal.setText("Cart is empty!");
                } else {
                    self.$refs.Loader.show();
                    self.post('AccountFeature/CreateMultiple', self.cartItems)
                        .then(res => {
                            self.$refs.Loader.hide();
                            self.$refs.SuccessModal.show(); // success modal
                            self.$refs.SuccessModal.setText("Purchased items!");
                            console.log("[PURCHASED-ITEMS]", self.cartItems)
                            self.cartItems = [];
                            self.cartItemCount = self.cartItems.length;
                            setTimeout(function () { // hide modal after 1 second
                                self.$refs.SuccessModal.hide();
                                self.$router.push("/account/features");
                            }, 1000)



                        })
                        .catch(err => {
                            console.log(err);
                            self.$refs.Loader.hide()
                            self.$refs.ErrorModal.show();
                            self.$refs.ErrorModal.setText("Failed to purchase items");
                        });
                }

            }
        },
    }
</script>

<style scoped>
    .toolbar-title {
        justify-content: flex-start !important;
        width: 100%;
    }

    .item {
        transition: 0.3s ease;
        cursor: pointer;
    }

    .item:hover {
        cursor: pointer;
        transform: scale(1.05, 1.05);
    }
</style>